<template>
  <div class="laboratory ma-0 mb-5">
    <div v-if="$i18n.locale=='tc'" class='my-2 subtitle-1 font-weight-medium'> {{ api.experiment_set_full_chi }}</div>
    <div v-else class='my-2 subtitle-1 font-weight-medium'> {{ api.experiment_set_full }}</div>
    <v-alert v-if="equipmentLock==true" border="left" color="red lighten-1" dark>
      <div v-if="$cookies.get('role')=='player'">
        <v-icon class="pr-3">mdi-alert</v-icon>
        {{ $t("experiment.alert.override_experiment_user") }}
      </div>
      <div v-else-if="$cookies.get('role')=='overrider'">
        <v-icon class="pr-3">mdi-alert</v-icon>
        {{ $t("experiment.alert.override_experiment_overrider") }}
      </div>
    </v-alert>
    <v-alert v-else-if="bookingLock==true" border="left" color="red lighten-1" dark>
      <div v-if="$cookies.get('role')=='player'">        
        <v-icon class="pr-3">mdi-alert</v-icon>
        {{ $t("experiment.alert.override_booking_user") }}
      </div>
      <div v-else-if="$cookies.get('role')=='overrider'">
        <v-icon class="pr-3">mdi-alert</v-icon>
        {{ $t("experiment.alert.override_booking_overrider") }}
      </div>
    </v-alert>
    <v-alert v-else-if="bookingLock==false && equipmentLock==false && $cookies.get('role')=='overrider'" border="left" color="red lighten-1" dark>
      <div>
        <v-icon class="pr-3">mdi-alert</v-icon>
        {{ $t("experiment.alert.override_enter_overrider") }}
      </div>
    </v-alert>
      <div v-if="loaded">
          <div v-if="name == 'apparent_depth'">
            <ApparentDepth @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride"/>
          </div>
          <div v-if="name == 'em_induction'">
            <EmInduction @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'interference'">
            <Interference @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>          
          <div v-if="name == 'greenhouse'">
            <Greenhouse @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'visible_spectrum'">
            <VisibleSpectrum @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>          
          <div v-if="name == 'air_monitoring'">
            <AirMonitoring @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <!--div v-if="name == 'bacteria_growth'">
            <BacteriaGrowth @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'photo_electric'">
            <PhotoElectric @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'radiation'">
            <Radiation @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'titration'">
            <Titration @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'ultrasound'">
            <Ultrasound @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'respiration'">
            <Respiration @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'photosynthesis'">
            <Photosynthesis @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'identify_unknown_anion'">
            <IdentifyUnknownAnion @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'kinetic_rate'">
            <KineticRate @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'spectrophotometry'">
            <Spectrophotometry @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'iodine_test'">
            <IodineTest @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'tensile_test'">
            <TensileTest @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'new_interference'">
            <NewInterference @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride" />
          </div>
          <div v-if="name == 'iot'">
            <IotExperiment @changeCheck="changeCheckBookingEnd" @changeOverride="changeOverride"/>
          </div-->
      </div>
    <v-overlay absolute :value="initialize">
              <v-progress-circular
      :size="50"
      :width="5"
      color="green accent-2"
      indeterminate
    ></v-progress-circular>
          </v-overlay>
  </div>
</template>
<script>
import ExperimentBasic from "@/services/iot/api_basic_experiment";
import ApparentDepth from "@/components/experiment/ApparentDepth.vue";
import EmInduction from "@/components/experiment/EmInduction.vue";
import Interference from "@/components/experiment/Interference.vue";
import Greenhouse from "@/components/experiment/Greenhouse.vue";
import VisibleSpectrum from "@/components/experiment/VisibleSpectrum.vue";
import AirMonitoring from "@/components/experiment/AirMonitoring.vue";
//import BacteriaGrowth from "@/components/BacteriaGrowth.vue";
//import PhotoElectric from "@/components/PhotoElectric.vue";
//import Radiation from "@/components/Radiation.vue";
//import Titration from "@/components/Titration.vue";
//import Ultrasound from "@/components/Ultrasound.vue";
//import Respiration from "@/components/Respiration.vue";
//import Photosynthesis from "@/components/Photosynthesis.vue";
//import IdentifyUnknownAnion from "@/components/IdentifyUnknownAnion.vue";
//import KineticRate from "@/components/KineticRate.vue";
//import Spectrophotometry from "@/components/Spectrophotometry.vue";
//import IodineTest from "@/components/IodineTest.vue";
//import TensileTest from "@/components/TensileTest.vue";
//import NewInterference from "@/components/NewInterference.vue";
//import IotExperiment from "@/components/iot.vue";


import {api_booking} from '@/services/iot/api_booking';
const apiBookingService = new api_booking(process.env.VUE_APP_BASE_URL);

export default {
  name: "experiment",
  components: {
    ApparentDepth,
    EmInduction,
    Interference,
    Greenhouse,
    VisibleSpectrum,
    AirMonitoring,
    //BacteriaGrowth,
    //PhotoElectric,
    //Radiation,
    //Titration,
    //Ultrasound,
    //Respiration,
    //Photosynthesis,
    //IdentifyUnknownAnion,
    //KineticRate,
    //Spectrophotometry,
    //IodineTest,
    //TensileTest,
    //NewInterference,
    //IotExperiment,
  },
  mixins: [ExperimentBasic],
  data: function () {
    return {
      name: "",
      override: 0,
      equipmentLock: false,
      bookingLock:false,
      bookingOverride: false,
      checkEnd: true,
      inte: null,
      role: null,
      drawer: true,
      initialize: true,
      loaded: false,
      mini: true,
      school_id: "",
      api:{
        school: null,
        school_name: null,
        school_chi_name: null,
        experiment: null,
        equipment_id: null,
        room_id: null,
        school_logo: null,
        experiment_name: null,
        experiment_set_full: null,
        experiment_set_full_chi: null,
      },
      title:{
        interference: 'INTERFERENCE',
      },
      room: {
        set_1: 'Room 1',
        set_2: 'Room 2',
        set_3: 'Room 3',
        set_4: 'Room 4',
        set_5: 'Room 1',
        set_1: 'Room 1',
      }
    };
  },
  mounted: function () {
    var self = this;
    self.name = self.$route.params.experiment;
    self.school_id = self.$route.params.school_id;
    self.experiment = self.$route.params.experiment;
    self.equipment_id = self.$route.params.equipment_id;
    self.$store.state.current.school_id = self.school_id;
    self.$store.state.current.experiment = self.experiment;
    self.$store.state.current.equipment_id = self.equipment_id;
        
    setTimeout(function(){
      if(self.$route.name == 'experiment'){
      }
      else {
        clearInterval(self.kick_inte);
      }
      self.initialization();
    },1000);
  },
  methods: {
    updateKickTime(time) {
      this.$emit("kickTime", (parseInt(time)*1000 - new Date().getTime())/1000);
    },
    initialization(){
      var self = this;
      apiBookingService.getSchool(self.school_id)
        .then((response) => {
          if(response.status=='success') {
            self.api.school = response.school;
            self.api.school_name = response.school_name;
            self.api.school_chi_name = response.school_chi_name;
            apiBookingService.getSchoolExperimentSet(self.school_id, self.experiment, self.equipment_id)
              .then((response) => {
                if(response.status=='success') {
                  self.api.experiment = self.experiment;
                  self.api.equipment_id = self.equipment_id;
                  apiBookingService.getEquipmentAndBookingStatus(self.$cookies.get("booking_id"),self.school_id, self.experiment, self.equipment_id)
                    .then((response) => {
                      if(response.eStatus=="HOLD")
                        self.equipmentLock = true;
                      if(response.bStatus=="SUSPENDED" || response.bStatus=="UNAVAILABLE" || response.bStatus=="MAINTENANCE")
                        self.bookingLock = true;
                      self.api.room_id = self.setRoomTranslate(self.api.equipment_id);
                      self.loaded = true;
                      self.initialize = false;
                      self.api.experiment_set_full = response.experiment_set_full;
                      self.api.experiment_set_full_chi = response.experiment_set_full_chi;
                      self.api.experiment_name = self.$store.state.experiment_name_translation[self.api.experiment];
                      if(self.equipmentLock == true && self.$cookies.get("role")=="overrider") {
                        //self.checkBookingEnd();
                      }
                      else self.checkBookingEnd();
                      self.inte = setInterval(function() {
                        if( self.equipmentLock == true && self.$cookies.get("role")=="overrider" ) {
                          // no action
                        }
                        else {
                          self.checkBookingEnd();
                        }
                      }, 10000);                      
                    });
                }
                else {
                  self.initialize = false;
                  alert(response.error);
                }
              });
          }
          else {
            self.initialize = false;
            alert(response.error);
          }
        });
    },
    setRoomTranslate(equipment_id){
      var self = this;
      let num = equipment_id.split('set_').pop();
      return "Room "+num;
    },
    changeCheckBookingEnd(){
      var self = this;
      self.checkEnd = !self.checkEnd;
    },
    changeOverride(override){
      var self = this;
      if (override.bStatus == "SUSPENDED")
        self.bookingLock = true;
      else 
        self.bookingLock = false;
      if (override.eStatus == "HOLD")
        self.equipmentLock = true;
      else 
        self.equipmentLock = false;
    },    
  },
  destroyed(){
    var self = this;
    clearInterval(self.inte);
    self.$cookies.remove("experiment");
    self.$cookies.remove("equipment_id");
    self.$cookies.remove("end_at");
    self.$cookies.remove("booking_id");
    self.$cookies.remove("session_token");
    self.$store.state.current.booking_id = null;
    self.$store.state.current.end_at = null;
    self.$store.state.current.school_id = null;
    self.$store.state.current.experiment = null;
    self.$store.state.current.equipment_id = null;
    console.log("destroyed");
  } 
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>